
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class OceanWavesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, width, height, time } = pc;
        const pts = Math.floor(30 * (config.parallaxComplexity || 1.0));
        const step = (width * 4) / pts;
        const curTime = time * config.parallaxSpeed;
        
        ctx.fillStyle = pc.color;

        const draw = () => {
            ctx.beginPath();
            ctx.moveTo(-width * 2, height);
            for (let i = -pts/2; i <= pts/2; i++) {
                const x = i * step;
                const y = height - (layerIndex * 100 * (config.parallaxScale || 1.0)) + Math.sin(x * 0.002 + curTime + layerIndex) * 50;
                ctx.lineTo(x, y);
            }
            ctx.lineTo(width * 2, height);
            ctx.fill();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
